import 'bootstrap/js/tooltip.js';
import 'bootstrap/js/popover.js';
angular.module('calendarApp').directive('descriptionPopover', function () {
  return {
    restrict: 'A',
    scope: {
      service: '=?',
      resource: '=?'
    },
    replace: false,
    link: function link(scope, elem, attrs) {
      var service = scope.service || null,
          resource = scope.resource || null;
      var $smoothPopover = $('<div>').addClass('smooth-popover'),
          $clearFix = $('<div>').addClass('clearfix'),
          $serviceSection = $('<div>').addClass('popover-section service-section'),
          $resourceSection = $('<div>').addClass('popover-section resource-section');
      var showService = service && service.name && (service.description || service.images && service.images.thumb);

      if (showService) {
        var $serviceHeading = $('<h5>').addClass('popover-heading');
        $serviceHeading.text(service.name);
        $smoothPopover.append($serviceHeading);

        if (service.images && service.images.thumb) {
          var $img = $('<img>').attr('src', service.images.thumb.url).addClass('popover-image service-popover-image');
          $serviceSection.append($img);
        }

        if (service.description) {
          var $serviceDescription = $('<p>').addClass('popover-description').html(service.description);
          $serviceSection.append($serviceDescription);
        }

        $serviceSection.append($clearFix);
        $smoothPopover.append($serviceSection);
      }

      var showResource = resource && resource.name && (resource.description || resource.images && resource.images.thumb);

      if (showResource) {
        var $resourceHeading = $('<h5>').addClass('popover-heading');
        $resourceHeading.text(resource.name);
        $smoothPopover.append($resourceHeading);

        if (resource.description) {
          var $resourceDescription = $('<p>').addClass('popover-description').html(resource.description);
          $resourceSection.append($resourceDescription);
        }

        if (resource.images && resource.images.thumb) {
          var $img = $('<img>').attr('src', resource.images.thumb.url).addClass('popover-image resource-popover-image');
          $resourceSection.append($img);
        }
      }

      if (!showService && !showResource) {
        $(elem).hide();
        return;
      }

      $smoothPopover.append($resourceSection);
      var $content = $('<div>').append($smoothPopover);
      $(elem).popover({
        'content': $content.html(),
        'placement': 'auto',
        'html': true,
        'trigger': 'hover'
      });
    }
  };
}); // End directive